const getIPFromBAIDUBCE = async () => {
    try {
        const response = await fetch(`https://qifu-api.baidubce.com/ip/local/geo/v1/district`);
        const {code,data,ip} = await response.json();
        if(code == 'Success' &&data.city) {
            return {
                ip: ip,
                country: data.country || '中国',
                province: data.prov || '',
                city: data.city || '',
                area:data.district || '',
                isp: data.isp || '',
            }
        }
    } catch (error) {
        console.error("Error fetching IP from baidubce:", error);
    }
};

export { getIPFromBAIDUBCE };